import {
  addPlugin,
  newTracker,
  setUserId,
  trackPageView,
  trackSelfDescribingEvent,
  trackStructEvent
} from '@snowplow/browser-tracker';
import {enableLinkClickTracking, LinkClickTrackingPlugin} from '@snowplow/browser-plugin-link-click-tracking';
import {PerformanceTimingPlugin} from '@snowplow/browser-plugin-performance-timing';
import {TimezonePlugin} from '@snowplow/browser-plugin-timezone';
import {DebuggerPlugin} from '@snowplow/browser-plugin-debugger';
import {EngagementTracking} from "./engagementTracking";

export function EntryPoint(_document, _window, _tracker_loader_script) {
  const _tracker_app_id = _tracker_loader_script.getAttribute("data-app") || "website";
  const _anonymousTracking = _tracker_loader_script.getAttribute("data-anonymous-tracking") === "true";
  let _debugEnabled = _tracker_loader_script.getAttribute("data-debug-enabled") === "true";
  const engagementTracking = EngagementTracking(_debugEnabled);

  function initAndTrack() {
    if (_debugEnabled) console.log("initAndTrack called");
    newTracker("trenecov3", "https://bd.eneco.be", {
      appId: _tracker_app_id,
      discoverRootDomain: true,
      anonymousTracking: _anonymousTracking,
      cookieLifetime: 60 * 60 * 24 * 365, //1 year (default is 2 years)
      postPath: '/be.eneco/v3',
      contexts: {webPage: true},
      plugins: [LinkClickTrackingPlugin(), PerformanceTimingPlugin(), TimezonePlugin()],
    });
    enableLinkClickTracking({pseudoClicks: true, trackContent: true});
    engagementTracking.setupLinkClickTrackingRefresh(0);
    engagementTracking.setupButtonClickTrackingWithRefresh(0, 0);
    if (_debugEnabled) {
      addPlugin({plugin: DebuggerPlugin()})
    }
    trackEnecoPageView();
  }

  function lookupUserId() {
    // the title bar is returned by the server HTML so no need to wait for a component to render
    // should have a div with spans that contain something like "Klantnummer: 123456789", can also have delivery address in the same info-container div
    const spanList = document.querySelectorAll('div.m-title-bar__info-container span');
    for (let spanNode of spanList) {
      const regExpMatchArray = spanNode.innerText.match('[0-9]{8,15}');
      if (regExpMatchArray && regExpMatchArray.length > 0) return regExpMatchArray[0];
    }
  }

  function trackEnecoPageView() {
    const userId = lookupUserId();
    if (userId) setUserId(userId);
    trackPageView();
  }

  function setDebug(debug) {
    _debugEnabled = debug;
  }

  initAndTrack();

  return {
    setDebug: setDebug,
    trackStructEvent: trackStructEvent,
    trackSelfDescribingEvent: trackSelfDescribingEvent
  };
}
